import React from 'react';
import { render, createPortal } from 'react-dom';
// components
import FindInstaller from '../components/find-installer/FindInstaller';
import GoogleMap from '../components/google-map/GoogleMap';
import SearchWidget from '../components/search-widget/SearchWidget';
import EnergyCalculator from '../components/energy-calculator/EnergyCalculator';
import ArcherCalculator from '../components/archer-calculator/ArcherCalculator';
// context
import GoogleMapsProvider from '../context/GoogleMapsProvider';
import CalculationContextProvider from '../components/energy-calculator/context/CalculationContext';
import ArcherContextProvider from '../components/archer-calculator/context/ArcherContext';

function ReactMountManager() {
    const appContainers = document.querySelectorAll('div[data-react]');
    const Components = Array.from(appContainers).map((container) => {
        const reactComponent = container.dataset.react;
        const props = container.dataset.props ? JSON.parse(container.dataset.props) : {};

        const Component = {
            'find-installer': FindInstaller,
            'google-map': GoogleMap,
            'search-widget': SearchWidget,
            'energy-calculator': EnergyCalculator,
            'archer-calculator': ArcherCalculator
        }[reactComponent] || null;

        return createPortal(<Component {...props} />, container);
    });

    return Components;
}

export default () => {
    render(
        <GoogleMapsProvider>
            <CalculationContextProvider>
                <ArcherContextProvider>
                    <ReactMountManager />
                </ArcherContextProvider>
            </CalculationContextProvider>
        </GoogleMapsProvider>,
        document.getElementById('reactRootNode')
    );
};
